export enum HttpHeader {
    Csrf = "X-CSRF-Token"
}
